var module = angular.module('octopusApp.configuration');

module.controller('TeamEditController', function($scope, $q, $stateParams, $location, $uibModal, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    var teamId = $stateParams["id"];

    var deletedThing = { Name: "(Deleted)" };
    var usersById = {};
    var rolesById = {};

    function init() {
        isLoading.promise(octopusRepository.Environments.all().then(function (environments) {
            $scope.environments = environments;
        }));

        isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function (status) {
            $scope.status = status;
        }));

        isLoading.promise(octopusRepository.Projects.all().then(function (projects) {
            $scope.projects = projects;
        }));
        
        isLoading.promise(octopusRepository.ProjectGroups.all().then(function (projectGroups) {
            $scope.projectGroups = projectGroups;
        }));

        isLoading.promise(octopusRepository.ExternalSecurityGroupProviders.all().then(function (providers) {
            $scope.externalGroupProviders = _.filter(providers, function (p) { return !p.IsRoleBased && p.SupportsGroupLookup; });
            $scope.hasRoleBasedGroupProviders = _.any(providers, function (p) { return p.IsRoleBased; });
        }));

        //Remote once we support tags and AdvancedTenant selector can be used.
        isLoading.promise((octopusRepository.Tenants ? octopusRepository.Tenants.all()  : $q.resolve([])).then(function (tenants) {
            $scope.allTenants = tenants;
        }));

        isLoading.promise(octopusRepository.UserRoles.all().then(function (userRoles) {
            isLoading.promise(octopusRepository.Users.all().then(function (users) {
                _.each(users, function (u) {
                    usersById[u.Id] = u;
                });
                _.each(userRoles, function (u) {
                    rolesById[u.Id] = u;
                });

                if (teamId) {
                    isLoading.promise(octopusRepository.Teams.get(teamId).then(function (result) {
                        $scope.team = result;
                        $scope.team.MemberUserIds = _.filter($scope.team.MemberUserIds, function (id) {
                            return !!usersById[id];
                        });
                        $scope.team.UserRoleIds = _.filter($scope.team.UserRoleIds, function (id) {
                            return !!rolesById[id];
                        });
                        pageTitle($scope.team.Name);

                    }));
                } else {
                    $scope.team = {
                        UserRoleIds: [],
                        ProjectIds: [],
                        TenantIds: [],
                        EnvironmentIds: [],
                        MemberUserIds: [],
                        ExternalSecurityGroups: [],
                        CanBeRenamed: true,
                        CanChangeRoles: true,
                        CanChangeMembers: true
                    };
                    pageTitle("Create team");
                }

                $scope.getRole = function (userRoleId) {
                    return rolesById[userRoleId] || deletedThing;
                };
                $scope.getUser = function (userId) {
                    return usersById[userId] || deletedThing;
                };
                $scope.removeMember = function (userId) {
                    $scope.team.MemberUserIds.splice($scope.team.MemberUserIds.indexOf(userId), 1);
                    unsavedChanges.unsaved();
                };
                $scope.removeExternalGroup = function (group) {
                    $scope.team.ExternalSecurityGroups.splice($scope.team.ExternalSecurityGroups.indexOf(group), 1);
                    unsavedChanges.unsaved();
                };
                $scope.removeRole = function (userRoleId) {
                    $scope.team.UserRoleIds.splice($scope.team.UserRoleIds.indexOf(userRoleId), 1);
                    unsavedChanges.unsaved();
                };
                $scope.deleteTeam = function () {
                    var dlg = octoDialog.confirmDelete('team', function () {
                        return octopusRepository.Teams.del($scope.team);
                    });
                    dlg.then(function (result) {
                        if (result) {
                            unsavedChanges.saved();
                            $location.path("/configuration/teams");
                        }
                    });
                };
            }));
        }));
    }

    var openRoleEditor = function(callback){
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/configuration/teams/views/edit_role_dialog.html',
            controller: 'TeamEditRoleDialogController'
        }).result.then(function(result) {
            if (result) {
                callback(result);
            }
        });
    };

    $scope.addRole = function(){
        openRoleEditor(function(result) {
            if (_.contains($scope.team.UserRoleIds, result)) {
                return;
            }
            unsavedChanges.unsaved();
            $scope.team.UserRoleIds.push(result);
        });
    };

    $scope.addMembers = function(){
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/configuration/teams/views/add_members_dialog.html',
            controller: 'TeamAddMembersDialogController'
        }).result.then(function(result) {
            if (result) {
                unsavedChanges.unsaved();
                _.each(result, function(member){
                    if (!_.contains($scope.team.MemberUserIds, member)) {
                        $scope.team.MemberUserIds.push(member);
                    }
                });
            }
        });
    };

    $scope.addExternalGroup = function(lookupUri){
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/configuration/teams/views/add_domain_group_dialog.html',
            controller: 'TeamAddDomainGroupDialogController',
            resolve: { lookupUri: function () { return lookupUri; } }
        }).result.then(function(result) {
            if (result) {
                unsavedChanges.unsaved();
                _.each(result, function(member){
                    $scope.team.ExternalSecurityGroups.push(member);
                });
            }
        });
    };

    $scope.addExternalRole = function(){
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/configuration/teams/views/add_external_role_dialog.html',
            controller: 'TeamAddExternalRoleDialogController'
        }).result.then(function(result) {
            if (result) {
                unsavedChanges.unsaved();
                $scope.team.ExternalSecurityGroups.push(result);
            }
        });
    };

    $scope.save = function() {
        isSaving.promise(octopusRepository.Teams.save($scope.team).then(function (result) {
            unsavedChanges.saved();
            $location.path("/configuration/teams");
        }));
    };
    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/teams/controllers/team_edit_controller.js
// module id = 8668012583083385
// module chunks = 1